export default function Chat(props) {
    const fill = props.fill ?? '#212121';

    return (
        <svg
            width="26"
            height="27"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M0 0h26v22H8l-8 5V0z" fill={fill} />
        </svg>
    );
}
